import React, { useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import ChangeIcon from "./ChangeIcon";
import FieldContainer from "./FieldContainer";
import TextField from "@mui/material/TextField";
import { debounce } from "lodash";

const Text = ({
  dynamicProperty,
  setProperty,
  propertyValue,
  propertyValidation,
  showWlrChangeIcon,
  recalculatePrices,
  validateConfig,
  disabled,
  margin,
}) => {
  useEffect(() => {
    validateConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyValue]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleDebouncedValidation = useCallback(
    debounce(() => {
      validateConfig();
    }, 500),
    []
  );

  const handleChange = (e) => {
    setProperty(e.target.value);
    handleDebouncedValidation(e.target.value);
  };

  return (
    <FieldContainer>
      <TextField
        variant="standard"
        fullWidth
        margin={margin ? "normal" : "none"}
        label={`${dynamicProperty.label}${
          dynamicProperty.is_required ? " *" : ""
        }`}
        onChange={handleChange}
        onBlur={() => {
          recalculatePrices();
          validateConfig();
        }}
        value={propertyValue || ""}
        disabled={disabled}
        helperText={propertyValidation}
        error={propertyValidation}
        name={dynamicProperty.name}
      />
      {showWlrChangeIcon && <ChangeIcon />}
    </FieldContainer>
  );
};

Text.propTypes = {
  dynamicProperty: PropTypes.object.isRequired,
  propertyValue: PropTypes.string,
};

export default Text;
